/** Shared wording of the Anonym-Ansicht (#140). */
// Only when the anonymized view is missing (fails closed); names are replaced, never hidden (#172).
export const HIDDEN_TEXT = "Text in der Anonym-Ansicht verborgen.";
export const HIDDEN_NOTES_TEXT = "Notizen sind in der Anonym-Ansicht verborgen.";
export const CLASSES_NOTE =
  "In [eckigen Klammern]: Firmenklasse statt Firmenname, [Hochschule] statt Hochschulname, [Wohnort] statt Ortsname";
